export default __webpack_public_path__ + "static/media/review.d50c44fb.png";